import { render, staticRenderFns } from "./CargarTicketMesa.vue?vue&type=template&id=62d4e5c5"
import script from "./CargarTicketMesa.vue?vue&type=script&lang=js"
export * from "./CargarTicketMesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports